import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Snackbar from 'components/common/Snackbar';
import Button from 'components/common/Button';

import { removeNotification } from 'redux/modules/notifications';

class NotificationsSnackbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      snackbarOpen: Boolean(props.message),
      snackbarEntered: false,
      message: props.message,
      variant: props.variant,
      actionHref: props.actionHref,
      actionText: props.actionText,
      onActionClick: props.onActionClick,
      download: props.download,
    };

    this.onSnackbarClose = this.onSnackbarClose.bind(this);
    this.onSnackbarExited = this.onSnackbarExited.bind(this);
    this.onSnackbarEntered = this.onSnackbarEntered.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { id } = this.props;
    const { snackbarEntered } = this.state;
    if (snackbarEntered && nextProps.count > 1) {
      this.setState({ snackbarOpen: false });
    } else if (nextProps.id
      && nextProps.id !== id) {
      this.setState({
        snackbarOpen: true,
        message: nextProps.message,
        variant: nextProps.variant,
        actionHref: nextProps.actionHref,
        actionText: nextProps.actionText,
        onActionClick: nextProps.onActionClick,
        download: nextProps.download,
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.enteredTimeout);
  }

  onSnackbarEntered() {
    this.enteredTimeout = setTimeout(() => {
      if (this.props.count > 1) {
        this.setState({ snackbarEntered: true });
        this.onSnackbarClose();
      } else {
        this.setState({ snackbarEntered: true });
      }
    }, this.props.delay);
  }

  onSnackbarClose() {
    this.setState({
      snackbarOpen: false,
      snackbarEntered: false,
    });
  }

  onSnackbarExited() {
    this.props.actions.removeNotification();
  }

  render() {
    const { snackbarOpen, message, variant, actionHref, actionText, onActionClick, download } = this.state;
    return (
      <Snackbar
        open={snackbarOpen}
        variant={variant}
        message={message || ''}
        autoHideDuration={3000}
        resumeHideDuration={0}
        onClose={this.onSnackbarClose}
        onEntered={this.onSnackbarEntered}
        onExited={this.onSnackbarExited}
        {...((actionHref || onActionClick) && actionText) ? {
          action: (
            <Button
              variant="raised"
              color="primary"
              href={actionHref}
              {...actionHref ? { href: actionHref } : {}}
              {...onActionClick ? { onClick: onActionClick } : {}}
              download={download}
              {...download ? { target: '_blank'} : {}}
            >
              {actionText}
            </Button>
          ),
        } : {}}
      />
    );
  }
}

NotificationsSnackbar.propTypes = {
  message: PropTypes.string,
  id: PropTypes.number,
  variant: PropTypes.oneOf(['default', 'warning', 'success', 'info']),
  actionText: PropTypes.string,
  actionHref: PropTypes.string,
  onActionClick: PropTypes.func,
  count: PropTypes.number.isRequired,
  delay: PropTypes.number,
  download: PropTypes.string,
  actions: PropTypes.shape({
    removeNotification: PropTypes.func.isRequired,
  }).isRequired,
};

NotificationsSnackbar.defaultProps = {
  message: null,
  id: null,
  actionText: null,
  actionHref: null,
  variant: 'default',
  download: null,
  delay: 1000,
  onActionClick: null,
};

const mapStateToProps = (store) => {
  const notification = store.notifications.data[0];
  return {
    message: notification ? notification.message : null,
    variant: notification ? notification.variant : null,
    id: notification ? notification.id : null,
    actionText: notification ? notification.actionText : null,
    actionHref: notification ? notification.actionHref : null,
    onActionClick: notification ? notification.onActionClick : null,
    download: notification ? notification.download : null,
    count: store.notifications.count,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ removeNotification }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsSnackbar);



// WEBPACK FOOTER //
// ./src/components/common/NotificationsSnackbar/NotificationsSnackbar.js